import React, { useState, useEffect } from "react";
import { Box, TextField, Button } from "@mui/material";
import { useNavigate, useParams } from "react-router-dom";
import MainDashboardLayout from "../../../../Layout/MainDashboardLayout";
import styles from "../../../../styles/gri/general.module.css";
import { put, get } from "../../../../utils/api";
import EastIcon from "@mui/icons-material/East";
import GRISidebar from "../../../../Layout/GRISidebar";
import ReviewBox from "../../../../Components/Common/ReviewBox";

import { currentYear } from "../../../../utils/generateYearRanges";

export default function GRI306_2({hide}) {
  const navigate = useNavigate();
  const { id } = useParams();
  const [disabled, setDisabled] = useState(false);
  const [formData, setFormData] = useState({
    wastePreventionActions: "",
    wasteManagementAssessment: "",
    wasteDataCollectionMonitoring: "",
  });
  const [griReview, setGriReview] = useState(() => JSON.parse(localStorage.getItem("griReview")));

  useEffect(() => {
    const handleStorage = () => {
      setGriReview(JSON.parse(localStorage.getItem("griReview")));
    };
    window.addEventListener("storage", handleStorage);
    return () => window.removeEventListener("storage", handleStorage);
  }, []);
  useEffect(() => {
    setGriReview(JSON.parse(localStorage.getItem("griReview")));
  }, []);

  const handleChange = (e) => {
    const { name, value } = e.target;
    const [main, sub] = name.split(".");
    setFormData((prev) => {
      if (sub) {
        return {
          ...prev,
          [main]: {
            ...prev[main],
            [sub]: value,
          },
        };
      } else {
        return { ...prev, [main]: value };
      }
    });
  };

  const fetchData = async () => {
    await get(`/gri/get?type=GRI300&Id=${id}`).then((res) => {
      if (res?.data?.data?.year ? res?.data?.data?.year < currentYear -1 : false) setDisabled(true);
      const response = res?.data?.data?.GRI300?.wasteImpactManagement;
      setFormData({
        wastePreventionActions: response?.wastePreventionActions,
        wasteManagementAssessment: response?.wasteManagementAssessment,
        wasteDataCollectionMonitoring: response?.wasteDataCollectionMonitoring,
      });
    });
  };

  useEffect(() => {
    fetchData();
  }, []);

  const handleSubmit = async () => {
    if (!disabled) {
      try {
        await put(`/gri/update?Id=${id}`, {
          type: "GRI300",
          wasteImpactManagement: { ...formData },
          submitted306_2: true,
        })
          .then((res) => navigate(`/gri/gri300/306-3/${id}`))
          .catch((err) => console.log(err));
      } catch (error) {
        console.log(error);
        // setsnackOpen({
        //   open: true,
        //   message: error.data.message,
        //   severity: "error",
        // });
      }
    } else {
      navigate(`/gri/gri300/306-3/${id}`);
    }
  };


  const renderContent = ({hide}) => (
      <>
      {!hide && <p className={styles.section_heading} >306 : Waste</p>}
      <p
        className={styles.main_heading}
        style={{
          // marginTop: "2.5rem",

          marginBottom: hide ? "-1rem"  : "0.5rem",
          display: "flex",
        }}
      >
        306-2: Management of significant waste related impacts
      </p>

      <Box>
        <p
          className={styles.ques_heading}
          style={{
            // marginTop: "2.5rem",

            marginBottom: "0.5rem",
            display: "flex",
          }}
        >
         
            a. Describe the actions, including circularity measures, implemented to
          prevent waste generation within the organization’s own activities and
          throughout its value chain, and to address significant impacts
          resulting from waste generated.
        </p>

        <TextField
          size="small"
          placeholder="Enter Text"
          fullWidth
          sx={{ padding: " 0px 18px" }}
          name={`wastePreventionActions`}
          value={formData?.wastePreventionActions}
          onChange={handleChange}
          //   error={errors.totalRecycled}
          disabled={disabled}
        />
        <p
          className={styles.ques_heading}
          style={{
            // marginTop: "2.5rem",

            marginBottom: "0.5rem",
            display: "flex",
          }}
        >
         
            b. If the waste generated by the organization in its own activities is
          managed by a third party, provide a description of the processes used
          to assess whether the third party manages the waste in accordance with
          contractual or legislative obligations.
        </p>

        <TextField
          size="small"
          placeholder="Enter Text"
          fullWidth
          sx={{ padding: " 0px 18px" }}
          name={`wasteManagementAssessment`}
          value={formData?.wasteManagementAssessment}
          onChange={handleChange}
          //   error={errors.totalRecycled}
          disabled={disabled}
        />
        <p
          className={styles.ques_heading}
          style={{
            // marginTop: "2.5rem",

            marginBottom: "0.5rem",
            display: "flex",
          }}
        >
          
            c. Outline the processes utilized for the collection and monitoring of
          waste-related data.
        </p>
        <TextField
          size="small"
          placeholder="Enter Text"
          fullWidth
          sx={{ padding: " 0px 18px" }}
          name={`wasteDataCollectionMonitoring`}
          value={formData?.wasteDataCollectionMonitoring}
          onChange={handleChange}
          //   error={errors.totalRecycled}
          disabled={disabled}
        />
      </Box>
     
    </>
  )

  return (
    <>
      {!hide ? (
        <MainDashboardLayout sidebar={<GRISidebar />}>
          {renderContent({ hide })}

          <>
            {!griReview ? (
        <Box sx={{ ml: "1rem", width: "98%" }}>
          <ReviewBox url={"/gri"} handleSubmit={handleSubmit} />
        </Box>
      ) : (
        <Box textAlign="right" sx={{ mt: 3 }}>
          <Button
            onClick={handleSubmit}
            variant="contained"
            sx={{ bgcolor: "#1C486B", textTransform: "none", mt: 3, mb: 5 }}
          >
            Save & Continue <EastIcon sx={{ ml: 2 }} />
          </Button>
        </Box>
      )}
          </>
        </MainDashboardLayout>
      ) : (
        renderContent({ hide })
      )}
    </>
  );
}
